export default "__VITE_ASSET__BW7vPNU6__"